import React, { useState } from "react";
import HeaderFour from "../common/header/HeaderFour";
import { Link } from "react-router-dom";
import FooterOne from "../common/footer/FooterOne";
import axios from "axios";
import API_URL from "../common/config";
import {
  ErrorNotification,
  SuccessNotification,
} from "../tosterNotification/tosters";

const ForgotPassword = () => {
  // States for each step in the process
  const [formData, setFormData] = useState({
    email: "",
    otp: "",
    password: "",
    confirmPassword: "",
  });
  const [step, setStep] = useState(1); // To track the current step (1 for email, 2 for OTP, 3 for password)
  const [errors, setErrors] = useState({});
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [disable, setDisable] = useState(false);

  // Email regex for validation
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  const passwordRegEx =
    /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;

  const handleEmailSubmit = async (e) => {
    e.preventDefault();

    // Validate email format using regex
    if (!formData.email) {
      setErrors({ email: "Email is required" });
      return;
    } else if (!emailRegex.test(formData.email)) {
      setErrors({ email: "Please enter a valid email address" });
      return;
    }

    try {
      console.log("Sending OTP to:", formData.email);
      const response = await axios.post(`${API_URL}/auth/forget-password-otp`, {
        email: formData.email,
      });
      if (response.data.success) {
        SuccessNotification("OTP sent successfully!");
        setDisable(true);
        setStep(2); // Move to OTP verification step
      } else {
        ErrorNotification("Something went wrong");
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      ErrorNotification("Error sending OTP. Please try again.");
    }
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    // Simulating OTP verification
    try {
      const response = await axios.post(`${API_URL}/auth/verify-otp`, {
        email: formData.email,
        otp: formData.otp,
      });
      if (response.data.success) {
        setIsOtpVerified(true);
        setStep(3); // Move to password setting step
      } else {
        setErrors({ otp: "Invalid OTP" });
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      ErrorNotification("Error verifying OTP. Please try again.");
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    // Password validation
    if (!formData.password || !passwordRegEx.test(formData.password)) {
      setErrors({
        password:
          "Password must have at least 8 characters, including uppercase and lowercase letters, a number, and a special character.",
      });
    } else if (formData.password !== formData.confirmPassword) {
      setErrors({ confirmPassword: "Passwords do not match" });
    } else {
      setErrors({});
      console.log("Password successfully updated");
      const response = await axios.post(
        `${API_URL}/auth/rest-password`,
        formData
      );
      if (response.data.success) {
        SuccessNotification("Password successfully updated!");
        // Redirect to login page
        setTimeout(() => {
          window.location.href = "/login";
        }, 2000);
      } else {
        ErrorNotification("Failed to update password");
      }
    }
  };

  const handleChange = (e, field) => {
    setFormData({ ...formData, [field]: e.target.value });
    // Reset errors on change (optional)
    setErrors({});
  };

  return (
    <>
      <main className="main-wrapper">
        <HeaderFour />
        <div
          className="section section-padding"
          style={{
            position: "relative",
          }}
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-5 col-lg-6 mt-5">
                <div className="contact-form-box shadow-box">
                  <div className="forgot-password-container">
                    {step === 1 && (
                      <div className="email-verification">
                        <h2>Forgot Password</h2>
                        <form onSubmit={handleEmailSubmit}>
                          <div className="form-group">
                            <label htmlFor="email">
                              Enter your email address
                            </label>
                            <input
                              type="email"
                              id="email"
                              className="form-control"
                              placeholder="ex : youremail@gmail.com"
                              value={formData.email}
                              onChange={(e) => handleChange(e, "email")}
                              required
                            />
                            {errors.email && (
                              <p className="text-red">{errors.email}</p>
                            )}
                          </div>
                          <button
                            type="submit"
                            disabled={disable}
                            className="btn btn-primary text-align-center"
                          >
                            Send OTP
                          </button>
                        </form>
                      </div>
                    )}

                    {step === 2 && !isOtpVerified && (
                      <div className="otp-verification">
                        <h2>Enter OTP</h2>
                        <form onSubmit={handleOtpSubmit}>
                          <div className="form-group">
                            <label htmlFor="otp">
                              Enter OTP sent to your email
                            </label>
                            <input
                              type="text"
                              id="otp"
                              className="form-control"
                              placeholder="Enter OTP "
                              value={formData.otp}
                              onChange={(e) => handleChange(e, "otp")}
                              required
                            />
                            {errors.otp && (
                              <p className="text-red">{errors.otp}</p>
                            )}
                          </div>
                          <button type="submit" className="btn btn-primary">
                            Verify OTP
                          </button>
                        </form>
                      </div>
                    )}

                    {step === 3 && isOtpVerified && (
                      <div className="password-reset">
                        <h2>Reset Password</h2>
                        <form onSubmit={handlePasswordSubmit}>
                          <div className="form-group">
                            <label htmlFor="password">New Password</label>
                            <input
                              type="password"
                              id="password"
                              placeholder="******"
                              className="form-control"
                              value={formData.password}
                              onChange={(e) => handleChange(e, "password")}
                              required
                            />
                            {errors.password && (
                              <p className="text-red">{errors.password}</p>
                            )}
                          </div>

                          <div className="form-group">
                            <label htmlFor="confirmPassword">
                              Confirm Password
                            </label>
                            <input
                              type="password"
                              id="confirmPassword"
                              className="form-control"
                              value={formData.confirmPassword}
                              placeholder="******"
                              onChange={(e) =>
                                handleChange(e, "confirmPassword")
                              }
                              required
                            />
                            {errors.confirmPassword && (
                              <p className="text-red">
                                {errors.confirmPassword}
                              </p>
                            )}
                          </div>

                          <button type="submit" className="btn btn-primary">
                            Reset Password
                          </button>
                        </form>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ul className="shape-group-8 list-unstyled">
            <li className="shape shape-1">
              <img
                src={process.env.PUBLIC_URL + "/images/others/bubble-9.png"}
                alt="Bubble"
              />
            </li>
            <li className="shape shape-2">
              <img
                src={process.env.PUBLIC_URL + "/images/others/bubble-11.png"}
                alt="Bubble"
              />
            </li>
            <li className="shape shape-3">
              <img
                src={process.env.PUBLIC_URL + "/images/others/line-4.png"}
                alt="Line"
              />
            </li>
          </ul>
        </div>
        <FooterOne />
      </main>
    </>
  );
};

export default ForgotPassword;
